import React from "react";
import Hero from "../components/UI/Hero";
import Features from "../components/UI/Features";
import CallToActionBox from "../components/UI/CallToActionBox";
import Faq from "../components/UI/Faq";
import Steps from "../components/UI/Steps";
import LiveAuctionsPreview from "../components/UI/LivePreview";
import { useTranslation } from "react-i18next";

const Landing = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Hero
        title={t("hero.landing.title")}
        subtitle={t("hero.landing.subtitle")}
        ctaLabel={t("hero.landing.cta_sell")}
        ctaLink="/registreties"
        ctaLabel2={t("hero.landing.cta_buy")}
        ctaLink2="/registreties"
      />
      <Features />
      <Steps />
      {/* <Faq /> */}
      {/* <LiveAuctionsPreview /> */}
      <CallToActionBox />
    </div>
  );
};

export default Landing;
